import { useContext, useEffect, useMemo } from 'react'
import { useWalletQuery } from 'hooks/queries/useWalletQuery'
import { useWalletsQueryV2 } from 'hooks/queries/useWalletsQueryV2'
import { useGetWalletLegacyId } from 'hooks/queries/Wallets/useGetWalletLegacyId'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { SourceWalletTypes } from 'types/move/move'
import { WalletType } from 'types/types'
import { WalletTypes } from 'types/wallets'
import { SourcePayWallet } from '../../Pay/types'
import { createSourcePayWallet } from '../utils'

interface UseWalletInitializationProps {
  sourceWalletAtom: SourcePayWallet | null
  setSourceWalletAtom: (wallet: SourcePayWallet) => void
}

export const useWalletInitialization = ({
  sourceWalletAtom,
  setSourceWalletAtom,
}: UseWalletInitializationProps) => {
  const [walletAction] = useContext(WalletActionContext)

  const { data: wallets, isFetching: isFetchingWallets } = useWalletsQueryV2({
    walletType: WalletTypes.FIAT,
    max: 600,
    order: 'asc',
    sort: 'description',
  })

  const { data: customerWalletLegacyId, isFetching: isFetchingCustomerWalletLegacyId } =
    useGetWalletLegacyId(walletAction?.meta?.customerWallet?.id)

  const { data: customerWallet, isFetching: isFetchingCustomerWallet } = useWalletQuery(
    customerWalletLegacyId,
    !!customerWalletLegacyId
  )

  useEffect(() => {
    if (isFetchingCustomerWallet) return

    if (customerWallet && !sourceWalletAtom?.walletId) {
      const sourceWallet = createSourcePayWallet(customerWallet, SourceWalletTypes.CUSTOMER)
      setSourceWalletAtom(sourceWallet)
      return
    }

    const activeWallets = wallets?.data || []

    if (
      !sourceWalletAtom?.walletId &&
      walletAction?.sourceWalletReference &&
      activeWallets?.length
    ) {
      const selectedWallet = activeWallets?.find(
        wallet => wallet?.lsid === walletAction?.sourceWalletReference
      ) as WalletType

      if (selectedWallet) {
        const sourceWallet = createSourcePayWallet(selectedWallet, SourceWalletTypes.MAIN)
        setSourceWalletAtom(sourceWallet)
      }
    }
  }, [
    sourceWalletAtom,
    walletAction?.sourceWalletReference,
    walletAction?.meta?.customerWallet?.id,
    wallets?.data,
    isFetchingCustomerWallet,
    customerWallet,
    setSourceWalletAtom,
  ])


  return useMemo(() => {
    return {
      wallets,
      customerWallet,
      isFetchingWallets,
      isFetchingCustomerWallet,
      isFetchingCustomerWalletLegacyId,
    }
  }, [wallets, customerWallet, isFetchingWallets, isFetchingCustomerWallet, isFetchingCustomerWalletLegacyId])


 
}
